module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Home","all":"All","stores":"Sunrise Stores"},"de":{"home":"Home","all":"Alle"}}')
  delete Component.options._Ctor
}
